import React from 'react';

const AlreadySignedUp = () => (
  <div className="h-signUpMessage font-semibold text-2xl">
    Hey! It seems you have already signed up!
  </div>
);

export default AlreadySignedUp;
